import store from "@/store";

// 外事业务类型
export const foreignAffairsCategoryList = [
  {
    value: 1,
    label: "Issue New Iqama 暂住证新办",
  },
  {
    value: 2,
    label: "Renew Iqama 暂住证延期",
  },
  {
    value: 3,
    label: "Single Exit Reentry Visa 单次往返签证",
  },
  {
    value: 4,
    label: "Multiple Exit Reentry Visa 多次往返签证",
  },
  {
    value: 5,
    label: "Extend Exit Reentry Visa 往返签证延期",
  },
  {
    value: 6,
    label: "Issue Busniess Visit Visa 商务访签办理",
  },
  {
    value: 7,
    label: "Busniess Visit Visa Extension 商务访签延期",
  },
  {
    value: 8,
    label: "Issue Working Visit Visa 工作访签办理",
  },
  {
    value: 9,
    label: "Wroking Visit Visa Extension 工作访签延期",
  },
  {
    value: 10,
    label: "Issue Temporary Working Visa 临时工作签证办理",
  },
  {
    value: 11,
    label: "Temporary Wroking Visa Extension 临时工作签证延期",
  },
  {
    value: 12,
    label: "Transfer Of Sponsorship 更换签证担保单位",
  },
  {
    value: 13,
    label: "Issue Visit Non-Working Country 第三国签证",
  },
  {
    value: 14,
    label: "Update Passport 护照信息更新",
  },
  {
    value: 15,
    label: "Cancel IQAMA 暂住证注销",
  },
  {
    value: 16,
    label: "Issue Exit Visa 离境签证办理",
  },
  {
    value: 17,
    label: "Ccancel Exit Visa 离境签证注销",
  },
  {
    value: 18,
    label: "Change IQAMA Profession IQAMA 更改职位",
  },
  {
    value: 19,
    label: "Cancel Exit Reentry 往返签证注销",
  },
  {
    value: 20,
    label: "驾照新办/Issue New Driving License",
  },
  {
    value: 21,
    label: "驾照延期/Renew Driving License",
  },
  {
    value: 99,
    label: "Other Payment 其他付费",
  },
];

//周期

export const monthList = [
  {
    value: 1,
    label: "1个月",
    label2: "一月",
  },
  {
    value: 2,
    label: "2个月",
    label2: "二月",
  },
  {
    value: 3,
    label: "3个月",
    label2: "三月",
  },
  {
    value: 4,
    label: "4个月",
    label2: "四月",
  },
  {
    value: 5,
    label: "5个月",
    label2: "五月",
  },
  {
    value: 6,
    label: "6个月",
    label2: "六月",
  },
  {
    value: 7,
    label: "7个月",
    label2: "七月",
  },
  {
    value: 8,
    label: "8个月",
    label2: "八月",
  },
  {
    value: 9,
    label: "9个月",
    label2: "九月",
  },
  {
    value: 10,
    label: "10个月",
    label2: "十月",
  },
  {
    value: 11,
    label: "11个月",
    label2: "十一月",
  },
  {
    value: 12,
    label: "12个月",
    label2: "十二月",
  },
];

export const jobNatureList = [
  {
    value: 1,
    label: "管理",
  },
  {
    value: 2,
    label: "非管理",
  },
];

export const monthList36 = [
  {
    value: 1,
    label: "1个月",
  },
  {
    value: 2,
    label: "2个月",
  },
  {
    value: 3,
    label: "3个月",
  },
  {
    value: 4,
    label: "4个月",
  },
  {
    value: 5,
    label: "5个月",
  },
  {
    value: 6,
    label: "6个月",
  },
  {
    value: 7,
    label: "7个月",
  },
  {
    value: 8,
    label: "8个月",
  },
  {
    value: 9,
    label: "9个月",
  },
  {
    value: 10,
    label: "10个月",
  },
  {
    value: 11,
    label: "11个月",
  },
  {
    value: 12,
    label: "12个月",
  },
  {
    value: 13,
    label: "13个月",
  },
  {
    value: 14,
    label: "14个月",
  },
  {
    value: 15,
    label: "15个月",
  },
  {
    value: 16,
    label: "16个月",
  },
  {
    value: 17,
    label: "17个月",
  },
  {
    value: 18,
    label: "18个月",
  },
  {
    value: 19,
    label: "19个月",
  },
  {
    value: 20,
    label: "20个月",
  },
  {
    value: 21,
    label: "21个月",
  },
  {
    value: 22,
    label: "22个月",
  },
  {
    value: 23,
    label: "23个月",
  },
  {
    value: 24,
    label: "24个月",
  },
  {
    value: 25,
    label: "25个月",
  },
  {
    value: 26,
    label: "26个月",
  },
  {
    value: 27,
    label: "27个月",
  },
  {
    value: 28,
    label: "28个月",
  },
  {
    value: 29,
    label: "29个月",
  },
  {
    value: 30,
    label: "30个月",
  },
  {
    value: 31,
    label: "31个月",
  },
  {
    value: 32,
    label: "32个月",
  },
  {
    value: 33,
    label: "33个月",
  },
  {
    value: 34,
    label: "35个月",
  },
  {
    value: 35,
    label: "35个月",
  },
  {
    value: 36,
    label: "36个月",
  },
];

//辅助物资类型
export const auxiliaryMaterialTypeList = [
  {
    value: 1,
    label: "消耗材料 Consumable",
  },
  {
    value: 2,
    label: "手段用料 Revolving Material",
  },
  {
    value: 3,
    label: "临设用料 Temporary Facility",
  },
  {
    value: 4,
    label: "工具 Tool",
  },
  {
    value: 99,
    label: "其他 Others",
  },
];

//安全物资类型
export const safetyMaterialTypeList = [
  {
    value: 1,
    label: "劳动防护用品 Safety Material",
  },
  {
    value: 2,
    label: "其他 Others",
  },
];

//内需物资类型
export const officeMaterialTypeList = [
  {
    value: 1,
    label: "办公用品 Office Material",
  },
  {
    value: 2,
    label: "办公耗材 Office Consumable",
  },

  {
    value: 99,
    label: "其他 Others",
  },
];

//需求周期
export const periodList = [
  {
    value: 1,
    label: "年度 Annual",
  },
  {
    value: 2,
    label: "季度 Quarter",
  },
  {
    value: 3,
    label: "月度 Monthly",
  },
  {
    value: 4,
    label: "临时 Temporary",
  },
  {
    value: 5,
    label: "紧急 Emergency",
  },
  {
    value: 99,
    label: "其他 Others",
  },
];

//是否转账
export const costControl = [
  {
    value: true,
    label: "是Yes",
  },
  {
    value: false,
    label: "否No",
  },
];

//外事关系
export const foreignList = [
  {
    value: 1,
    label: "Inside",
  },
  {
    value: 2,
    label: "Holding",
  },
  {
    value: 3,
    label: "Cancel",
  },
  {
    value: 4,
    label: "Pending",
  },
  {
    value: 5,
    label: "Vacation",
  },
  {
    value: 6,
    label: "Visiting",
  },
];

//默认签证类型
export const SPONSORList = [
  {
    label: "SNEI",
    value: 1,
  },
  {
    label: "SEG",
    value: 2,
  },
  {
    label: "其它",
    value: 3,
  },
];

//审核状态
export const auditStatusList = [
  {
    value: 0,
    label: "待审核",
  },
  {
    value: 1,
    label: "审核通过",
  },
  {
    value: 2,
    label: "审核中",
  },
  {
    value: 3,
    label: "审核未通过",
  },
  {
    value: 4,
    label: "驳回",
  },
];

//薪资

export const salaryList = [
  {
    value: 1,
    label: "基本工资标准_外籍",
    name: "JBGZBZWJ",
  },
  {
    value: 2,
    label: "食宿补贴标准_外籍",
    name: "SSBTBZWJ",
  },
  {
    value: 3,
    label: "交通补贴标准_外籍",
    name: "ZDYX1",
  },
  {
    value: 4,
    label: "两小时补助_外籍",
    name: "ZDYX8",
  },
  {
    value: 5,
    label: "绩效奖金标准-外籍",
    name: "ZDYX4",
  },
  {
    value: 6,
    label: "GOSI扣减系数",
    name: "GOSIKJXS",
  },
  {
    value: 7,
    label: "基本薪酬",
    name: "GNGZJXBZ",
  },
  {
    value: 8,
    label: "住房补贴",
    name: "ZFBTBZ",
  },
  {
    value: 9,
    label: "岗位补贴",
    name: "GWBTBZ",
  },
  {
    value: 10,
    label: "技术津贴",
    name: "DQBTBZ",
  },
  {
    value: 11,
    label: "生活津贴",
    name: "YWGZBTBZ",
  },
  {
    value: 12,
    label: "假日加班工资",
    name: "JRJBGZBZ",
  },
  {
    value: 13,
    label: "节日加班工资",
    name: "JIERJBGZBZ",
  },
  {
    value: 14,
    label: "加点标准",
    name: "JDBZ",
  },
  {
    value: 15,
    label: "保险津贴",
    name: "ZDYX9",
  },
  {
    value: 16,
    label: "海外工作补贴",
    name: "JBXC",
  },
  {
    value: 17,
    label: "保留工资",
    name: "BLGZ",
  },
  {
    value: 18,
    label: "组伙长津贴",
    name: "ZHZJT",
  },
  {
    value: 19,
    label: "高技术技能津贴",
    name: "GJSJNJT",
  },
  {
    value: 20,
    label: "房租补贴",
    name: "FZBT",
  },
  {
    value: 21,
    label: "加班日工资",
    name: "JBRGZ",
  },
  {
    value: 22,
    label: "南京市企业最低月工资标准",
    name: "NJSQYZDGZBZ",
  },
  {
    value: 23,
    label: "艰苦补贴系数",
    name: "JKBTXS",
  },
  {
    value: 24,
    label: "艰苦补贴基数",
    name: "JKBTJS",
  },
  {
    value: 25,
    label: "考勤模式",
    name: "KQMS",
  },
  {
    value: 26,
    label: "国内其他津补贴",
    name: "GNQTBT",
  },
  {
    value: 27,
    label: "绩效奖金-比例标准",
    name: "PerformanceBonusRatioValue",
  },
  {
    value: 28,
    label: "绩效奖金-定额单价",
    name: "PerformanceBonusQuotaValue",
  },
  {
    value: 29,
    label: "基本工资-GOSI注册",
    name: "ZDYX5",
  },
  {
    value: 30,
    label: "住房补贴-注册",
    name: "ZDYX6",
  },
  {
    value: 31,
    label: "医疗补贴标准-外籍",
    name: "ZDYX2",
  },
  {
    value: 32,
    label: "工龄补贴标准-外籍",
    name: "ZDYX3",
  },
  {
    value: 33,
    label: "GOSI标准-外籍",
    name: "GOSIBZWJ",
  },
];

//性别
export const genderList = [
  {
    value: 1,
    label: "男",
  },
  {
    value: 2,
    label: "女",
  },
  {
    value: 3,
    label: "未知",
  },
];

//业务分类
export const tablesList = [
  {
    key: "renliziyuan",
    value: "人力资源",
    index: "renliziyuan",
    children: [
      {
        key: "renlidiaopei",
        index: "renlidiaopei",
        value: "人力调配",
        children: [
          {
            index: "ManpowerRequest",
            key: "ManpowerRequest",
            value: "人力资源招聘审批",
          },

          {
            index: "InternalTemporaryManpowerApplication",
            key: "InternalTemporaryManpowerApplication",
            value: "内部借工审批",
          },
          {
            index: "CostAllocation8",
            key: "CostAllocation",
            value: "内部借工费用分割审批",
          },
          {
            index: "EmployeeInternalTransferOrderApplication",
            key: "EmployeeInternalTransferOrderApplication",
            value: "人员调转审批",
          },
          {
            index: "DemobilizationApplication",
            key: "DemobilizationApplication",
            value: "人员撤离审批",
          },
        ],
      },
      {
        key: "bentuhuayonggong",
        index: "bentuhuayonggong",
        value: "本土化用工",
        children: [
          {
            index: "CostAllocation1",
            key: "CostAllocation",
            value: "沙化费用分割审批",
          },
          {
            index: "CostAllocation2",
            key: "CostAllocation",
            value: "沙特籍培训费用分割审批",
          },
          {
            index: "CostAllocation3",
            key: "CostAllocation",
            value: "HRDF返还费用审批",
          },
        ],
      },
      {
        key: "dangdiwaibao",
        index: "dangdiwaibao",
        value: "当地外包",

        children: [
          {
            key: "waibaodangweiguanli",
            index: "waibaodangweiguanli",
            value: "外包单位管理",
            children: [
              {
                index: "ManpowerSupplier",
                key: "ManpowerSupplier",
                value: "外包单位引入审批",
              },
            ],
          },
          {
            key: "danjiajipoguanli",
            index: "danjiajipoguanli",
            value: "单价及PO管理",
            children: [
              {
                index: "ManpowerRecruitmentHourlyRate",
                key: "ManpowerRecruitmentHourlyRate",
                value: "外包人员指导价审批",
              },
              {
                index: "PurchaseOrderApplication",
                key: "PurchaseOrderApplication",
                value: "外包单位订单审批",
              },
            ],
          },
          {
            key: "feiyongguanli",
            index: "feiyongguanli",
            value: "费用管理",
            children: [
              {
                index: "ManpowerSupplierMonthlyCostApplication",
                key: "ManpowerSupplierMonthlyCostApplication",
                value: "月度挂账审批",
              },
            ],
          },
        ],
      },
      {
        key: "peixunkaifa",
        index: "peixunkaifa",
        value: "培训开发",
        children: [
          {
            key: "TrainingCourseApplication",
            index: "TrainingCourseApplication",
            value: "年度培训班计划审批",
          },
        ],
      },
      {
        key: "gangweibiandong",
        index: "gangweibiandong",
        value: "岗位变动",
        children: [
          {
            key: "PositionAdjustmentApplicantion",
            index: "PositionAdjustmentApplicantion",
            value: "员工岗位变动审批",
          },
        ],
      },
      {
        key: "jiaqinguanli",
        index: "jiaqinguanli",
        value: "假勤管理",
        children: [
          {
            key: "EmployeeLeaveApplication",
            index: "EmployeeLeaveApplication1",
            value: "病事假审批",
          },
          {
            key: "EmployeeLeaveApplication",
            index: "EmployeeLeaveApplication2",
            value: "福利假审批",
          },

          {
            key: "dingqixiujiashenpi",
            index: "dingqixiujiashenpi",
            value: "定期休假审批",
            children: [
              {
                key: "EmployeeLeaveApplication",
                index: "EmployeeLeaveApplication3",
                value: "定期休假审批",
              },
            ],
          },
          {
            key: "EmployeeOvertimeWorkingApplication",
            index: "EmployeeOvertimeWorkingApplication",
            value: "加班审批",
          },
        ],
      },
      {
        key: "xinziguanli",
        index: "xinziguanli",
        value: "薪资管理",
        children: [
          {
            index: "CostAllocation7",
            key: "CostAllocation",
            value: "EOSB费用计提审批",
          },
          {
            key: "xinziguanli",
            index: "xinziguanli",
            value: "薪资设置",
            children: [
              {
                index: "EmployeeSalaryAdjustmentApplication",
                key: "EmployeeSalaryAdjustmentApplication",
                value: "员工薪资标准调整审批",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    key: "waishiyewu",
    value: "外事业务",
    index: "waishiyewu",
    children: [
      {
        key: "gonzuoqianzheng",
        value: "工作签证",
        index: "gonzuoqianzheng",
        children: [
          {
            key: "WorkVisaApplication",
            value: "工作签证指标购买审批",
            index: "WorkVisaApplication1",
          },
          {
            key: "WorkVisaApplication",
            value: "工作签证指标授权审批",
            index: "WorkVisaApplication2",
          },
          {
            key: "WorkVisaApplication",
            value: "工作签证指标取消授权审批",
            index: "WorkVisaApplication3",
          },
          {
            key: "WorkVisaApplication",
            value: "工作签证指标退还记录",
            index: "WorkVisaApplication4",
          },
          {
            key: "WorkVisaApplication",
            value: "工作签证指标使用计划审批",
            index: "WorkVisaApplication6",
          },
          {
            key: "EmployeeVisaApplication",
            value: "员工签证使用审批",
            index: "EmployeeVisaApplication",
          },
          {
            key: "ForeignAffairsApplication",
            value: "临时工作签证延期审批",
            index: "ForeignAffairsApplication11",
          },
        ],
      },
      {
        key: "zanzhuzheng",
        value: "暂住证",
        index: "zanzhuzheng",
        children: [
          {
            key: "ForeignAffairsApplication",
            value: "暂住证办理审批",
            index: "ForeignAffairsApplication1",
          },
          {
            key: "ForeignAffairsApplication",
            value: "暂住证延期审批",
            index: "ForeignAffairsApplication2",
          },
          {
            key: "ForeignAffairsApplication",
            value: "暂住证注销审批",
            index: "ForeignAffairsApplication15",
          },
          {
            key: "ForeignAffairsApplication",
            value: "暂住证职位更改审批",
            index: "ForeignAffairsApplication18",
          },
        ],
      },
      {
        key: "churujingqianzheng",
        value: "出入境签证",
        index: "churujingqianzheng",
        children: [
          {
            key: "ForeignAffairsApplication",
            value: "单次往返签证办理审批 ",
            index: "ForeignAffairsApplication3",
          },
          {
            key: "ForeignAffairsApplication",
            value: "多次往返签证办理审批",
            index: "ForeignAffairsApplication4",
          },
          {
            key: "ForeignAffairsApplication",
            value: "往返签证延期审批",
            index: "ForeignAffairsApplication5",
          },
          {
            key: "ForeignAffairsApplication",
            value: "往返签证延期审批",
            index: "ForeignAffairsApplication19",
          },
          {
            key: "ForeignAffairsApplication",
            value: "离境签证办理审批",
            index: "ForeignAffairsApplication16",
          },
          {
            key: "ForeignAffairsApplication",
            value: "离境签证注销审批",
            index: "ForeignAffairsApplication17",
          },
        ],
      },
      {
        key: "dangdifangwenqianzheng",
        value: "当地访问签证",
        index: "dangdifangwenqianzheng",
        children: [
          {
            key: "InvitationLetterApplication",
            value: "访问签证邀请函审批",
            index: "InvitationLetterApplication",
          },
          {
            key: "FamilyVisitVisaNvitationLetterApplication",
            value: "家庭访签邀请函审批",
            index: "FamilyVisitVisaNvitationLetterApplication",
          },
          {
            key: "ForeignAffairsApplication",
            value: "商务访签延期审批",
            index: "ForeignAffairsApplication7",
          },
        ],
      },
      {
        key: "yingonglingshichujing",
        value: "因公临时出境",
        index: "yingonglingshichujing",
        children: [
          {
            key: "OverseasWorksApplication",
            value: "因公临时出境任务审批",
            index: "OverseasWorksApplication",
          },
          {
            key: "ForeignAffairsApplication",
            value: "第三国访问签证办理审批",
            index: "ForeignAffairsApplication13",
          },
        ],
      },

      {
        key: "guoyuanzhuanbao",
        value: "雇员转保",
        index: "guoyuanzhuanbao",
        children: [
          {
            key: "ForeignAffairsApplication",
            value: "雇员转保",
            index: "ForeignAffairsApplication12",
          },
        ],
      },
      {
        key: "dangdiyibao",
        value: "当地医保",
        index: "dangdiyibao",
        children: [
          {
            key: "EmployeeMedicalInsuranceRegistrationApplication",
            value: "员工医保注册审批",
            index: "EmployeeMedicalInsuranceRegistrationApplication",
          },
          {
            key: "EmployeeMedicalInsuranceAdjustmentmentApplication",
            value: "员工医保等级变更审批",
            index: "EmployeeMedicalInsuranceAdjustmentmentApplication",
          },
          {
            key: "CostAllocation",
            value: "医保费用分割审批",
            index: "CostAllocation5",
          },
        ],
      },
      {
        key: "dangdishebao",
        value: "当地社保",
        index: "dangdishebao",
        children: [
          {
            key: "EmployeeWagestoGOSIAppliction",
            value: "员工社保注册审批",
            index: "EmployeeWagestoGOSIAppliction1",
          },
          {
            key: "EmployeeWagestoGOSIAppliction",
            value: "员工社保变更审批",
            index: "EmployeeWagestoGOSIAppliction3",
          },
          {
            key: "CostAllocation",
            value: "GOSI费用分割审批",
            index: "CostAllocation6",
          },
          {
            key: "PersonalInjurySiteGOSIInformationApplication",
            value: "GOSI工伤报告",
            index: "PersonalInjurySiteGOSIInformationApplication",
          },
        ],
      },

      {
        key: "huzhaoguanli",
        value: "护照管理",
        index: "huzhaoguanli",
        children: [
          {
            key: "ForeignAffairsApplication",
            value: "护照信息更新审批",
            index: "ForeignAffairsApplication14",
          },
        ],
      },
      {
        key: "dangdijiazhao",
        value: "当地驾照",
        index: "dangdijiazhao",
        children: [
          {
            key: "ForeignAffairsApplication",
            value: "当地驾照新办审批",
            index: "ForeignAffairsApplication20",
          },
          {
            key: "ForeignAffairsApplication",
            value: "当地驾照延期审批",
            index: "ForeignAffairsApplication21",
          },
        ],
      },
      {
        key: "feiyongguanli",
        value: "费用管理",
        index: "feiyongguanli",
        children: [
          {
            key: "ForeignAffairsPaymentSummaryApplication",
            value: "外事付费审批",
            index: "ForeignAffairsPaymentSummaryApplication",
          },
        ],
      },
    ],
  },
  {
    key: "hangkongpiaowu",
    value: "航空票务",
    index: "hangkongpiaowu",
    children: [
      {
        key: "piaodaiguanli",
        value: "票代管理",
        index: "piaodaiguanli",
        children: [
          {
            key: "NewTicketingAgentApplication",
            value: "票代引入审批",
            index: "NewTicketingAgentApplication",
          },
        ],
      },
      {
        key: "piaowuguanli",
        value: "票务管理",
        index: "piaowuguanli",
        children: [
          {
            key: "EmployeeFlightTicketApplication",
            value: "机票请购审批",
            index: "EmployeeFlightTicketApplication",
          },
          {
            key: "FlightTicketRescheduleApplication",
            value: "机票变更审批",
            index: "FlightTicketRescheduleApplication",
          },
          {
            key: "jipiaofufeiguanli",
            value: "机票付费管理",
            index: "jipiaofufeiguanli",
            children: [
              {
                key: "feiyonghuizong",
                value: "费用汇总",
                index: "feiyonghuizong",
                children: [
                  {
                    key: "CostAllocation",
                    value: "分割单汇总",
                    index: "CostAllocation4",
                  },
                  {
                    key: "TicketFarePaymentSummaryApplication",
                    value: "付款通知单汇总",
                    index: "TicketFarePaymentSummaryApplication",
                  },
                ],
              },
            ],
          },

          {
            key: "CostAllocation",
            value: "机票费用分割审批",
            index: "CostAllocation4",
          },
        ],
      },
    ],
  },

  {
    key: "gonggonganquan",
    value: "公共安全",
    index: "gonggonganquan",
    children: [
      {
        key: "jingwaigonggoanquanpeixun",
        value: "境外公共安全培训",
        index: "jingwaigonggoanquanpeixun",
        children: [
          {
            index: "RegistrationforPublicSafetyTrainingApplication",
            key: "RegistrationforPublicSafetyTrainingApplication",
            value: "公共安全培训审批",
          },
          {
            index: "CostAllocation10",
            key: "CostAllocation",
            value: "境外公共安全培训费用",
          },
        ],
      },
      {
        key: "renshengyiwanshanghanbaoxsos",
        value: "人身意外伤害保险&SOS",
        index: "renshengyiwanshanghanbaoxsos",
        children: [
          {
            index: "CostAllocation9",
            key: "CostAllocation",
            value: "人身意外伤害保险费用",
          },
        ],
      },
    ],
  },
  {
    key: "yuangonglaobao",
    value: "员工劳保",
    index: "changbenfeiyong",
    children: [
      {
        key: "AuxiliaryMaterialApplication",
        value: "劳动防护用品年度计划审批",
        index: "AuxiliaryMaterialApplication",
      },
      {
        key: "PPERequestApplication",
        value: "劳动防护用品申领审批",
        index: "PPERequestApplication",
      },
    ],
  },
  {
    key: "changbenfeiyong",
    value: "成本费用",
    index: "changbenfeiyong",
    children: [
      {
        key: "ForeignAffairsApplication",
        value: "其他付费",
        index: "ForeignAffairsApplication99",
      },
    ],
  },
  {
    key: "yuangongzizhu",
    value: "员工自助",
    index: "yuangongzizhu",
    children: [
      {
        key: "EmployeeCertificateApplication",
        value: "收入证明",
        index: "EmployeeCertificateApplication1",
      },
      {
        key: "EmployeeCertificateApplication",
        value: "工作证明",
        index: "EmployeeCertificateApplication2",
      },
      {
        key: "EmployeeCertificateApplication",
        value: "离职证明",
        index: "EmployeeCertificateApplication3",
      },
    ],
  },
];

//处理业务分类
export const updateTableValue = (data, a, b, c) => {
  return data.map((item) => {
    // 创建新对象，避免修改原数据
    const newItem = { ...item };

    // 如果当前节点的key匹配，则修改value
    if (newItem.index === a) {
      if (!newItem.value.endsWith(")")) {
        if (c) {
          if (c === newItem.key) {
            newItem.value = `${newItem.value}(${b})`;
          } else {
            newItem.value = `${newItem.value}`;
          }
        } else {
          newItem.value = `${newItem.value}(${b})`;
        }
      } else {
        const match = newItem.value.match(/\((\d+)\)$/);
        let parts = newItem.value.split("(");
        console.log("parts", parts[0], match);
        if (c) {
          if (c === newItem.key) {
            newItem.value = `${parts[0]}(${parseInt(match[1]) + b})`;
          } else {
            newItem.value = `${newItem.value}`;
          }
        } else {
          newItem.value = `${parts[0]}(${parseInt(match[1]) + b})`;
        }
      }
    }

    // 递归处理子节点
    if (newItem.children && newItem.children.length > 0) {
      newItem.children = updateTableValue(newItem.children, a, b, c);
    }

    return newItem;
  });
};

// 获取typeID
export const splitStringIfEndsWithNumber = (str) => {
  // 使用正则表达式匹配末尾的数字
  const match = str.match(/^(.*?)(\d+)$/);

  if (match) {
    // 如果匹配成功，返回拆分后的两部分
    return {
      base: match[1],
      number: parseInt(match[2], 10),
    };
  } else {
    // 如果没有数字结尾，返回原字符串和null
    return {
      base: str,
      number: null,
    };
  }
};

export const processTableData = (data) => {
  // 深拷贝数据，避免修改原数据
  const clonedData = JSON.parse(JSON.stringify(data));

  function processNode(node) {
    // 如果是叶子节点（没有children），尝试提取括号中的数字
    if (!node.children || node.children.length === 0) {
      const match = node.value.match(/\((\d+)\)$/);
      if (match) {
        return parseInt(match[1], 10);
      }
      return 0;
    }

    // 处理子节点并计算总和
    let total = 0;
    node.children.forEach((child) => {
      total += processNode(child);
    });

    // 如果子节点有数字，就在当前节点的value后面添加总和
    if (total > 0) {
      node.value = `${node.value}(${total})`;
    }

    return total;
  }

  // 处理每个根节点
  clonedData.forEach((item) => {
    processNode(item);
  });

  return clonedData;
};

export const LeaveTypes = [
  {
    name: "病假",
    nameEn: "Sick Leave",
    allName: "病假(Sick Leave)",
    value: 1,
  },
  {
    name: "事假",
    nameEn: "Personal Leave",
    allName: "事假(Personal Leave)",
    value: 2,
  },
  {
    name: "工伤",
    nameEn: "Job Injuries",
    allName: "工伤(Job Injuries)",
    value: 3,
  },
  {
    name: "婚假",
    nameEn: "Marriage Leave",
    allName: "婚假(Marriage Leave)",
    value: 4,
  },
  {
    name: "丧假",
    nameEn: "Bereavement Leave",
    allName: "丧假(Bereavement Leave)",
    value: 5,
  },
  {
    name: "护理假",
    nameEn: "Child Birth Leave",
    allName: "护理假(Child Birth Leave)",
    value: 6,
  },
  {
    name: "朝觐",
    nameEn: "Hajj Leave",
    allName: "朝觐(Hajj Leave)",
    value: 7,
  },
  {
    name: "育儿假",
    nameEn: "Parental Leave",
    allName: "育儿假(Parental Leave)",
    value: 8,
  },
  {
    name: "独生子女护理假",
    nameEn: "Only Child Care Leave",
    allName: "独生子女护理假(Only Child Care Leave)",
    value: 9,
  },
  {
    name: "定期休假",
    nameEn: "Regular Leave",
    allName: "定期休假(Regular Leave)",
    value: 10,
  },
];

//员工信息类型
export const employeeInfoType = [
  {
    value: 1,
    label: "基础信息 Basic Information",
  },
  {
    value: 2,
    label: "工作信息 Work Information",
  },
  {
    value: 3,
    label: "资格能力 Qualification Ability",
  },
  {
    value: 4,
    label: "外事信息 Foreign Affairs Information",
  },
  {
    value: 5,
    label: "银行账户 Bank Account",
  },
];

//员工信息子类型
export const employeeInfoSubType = [
  {
    value: 1,
    label: "员工编号",
    type: 1,
    InfoType: 1,
  },
  {
    value: 2,
    label: "姓名",
    type: 1,
    InfoType: 1,
  },
  {
    value: 3,
    label: "NAME",
    type: 1,
    InfoType: 1,
  },
  {
    value: 4,
    label: "性别",
    type: 1,
    InfoType: 2,
  },
  {
    value: 5,
    label: "国籍",
    type: 1,
    InfoType: 2,
  },
  {
    value: 6,
    label: "民族",
    type: 1,
    InfoType: 2,
  },
  {
    value: 7,
    label: "身份证号码",
    type: 1,
    InfoType: 1,
  },
  {
    value: 8,
    label: "出生日期",
    type: 1,
    InfoType: 3,
  },
  {
    value: 9,
    label: "籍贯",
    type: 1,
    InfoType: 1,
  },
  {
    value: 10,
    label: "户口所在地",
    type: 1,
    InfoType: 1,
  },
  {
    value: 11,
    label: "常住地址",
    type: 1,
    InfoType: 1,
  },
  {
    value: 12,
    label: "国内电话",
    type: 1,
    InfoType: 1,
  },
  {
    value: 13,
    label: "当地电话",
    type: 1,
    InfoType: 1,
  },
  {
    value: 14,
    label: "电子邮箱",
    type: 1,
    InfoType: 1,
  },
  {
    value: 15,
    label: "公司邮箱",
    type: 1,
    InfoType: 1,
  },
  {
    value: 16,
    label: "政治面貌",
    type: 1,
    InfoType: 2,
  },
  {
    value: 17,
    label: "宗教信仰",
    type: 1,
    InfoType: 2,
  },
  {
    value: 18,
    label: "婚姻情况",
    type: 1,
    InfoType: 2,
  },
  {
    value: 19,
    label: "紧急联系人",
    type: 1,
    InfoType: 1,
  },
  {
    value: 20,
    label: "与本人的关系",
    type: 1,
    InfoType: 1,
  },
  {
    value: 21,
    label: "紧急联系人电话",
    type: 1,
    InfoType: 1,
  },
  {
    value: 22,
    label: "最高学历",
    type: 1,
    InfoType: 2,
  },
  {
    value: 23,
    label: "最高学位",
    type: 1,
    InfoType: 2,
  },
  {
    value: 24,
    label: "所学专业",
    type: 1,
    InfoType: 2,
  },
  {
    value: 25,
    label: "毕业院校",
    type: 1,
    InfoType: 2,
  },
  {
    value: 26,
    label: "毕业时间",
    type: 1,
    InfoType: 3,
  },
  {
    value: 27,
    label: "参加工作时间",
    type: 1,
    InfoType: 3,
  },
  {
    value: 28,
    label: "掌握语种",
    type: 1,
    InfoType: 2,
  },
  {
    value: 29,
    label: "语言能力",
    type: 1,
    InfoType: 1,
  },
  {
    value: 30,
    label: "职位序列",
    type: 2,
    InfoType: 2,
  },
  {
    value: 31,
    label: "职位名称",
    type: 2,
    InfoType: 1,
  },
  {
    value: 32,
    label: "用工形式",
    type: 2,
    InfoType: 2,
  },
  {
    value: 33,
    label: "成本归集",
    type: 2,
    InfoType: 2,
  },
  {
    value: 34,
    label: "用工协议签署单位",
    type: 2,
    InfoType: 2,
  },
  {
    value: 35,
    label: "所属单位",
    type: 2,
    InfoType: 1,
  },
  {
    value: 36,
    label: "进入本单位时间",
    type: 2,
    InfoType: 3,
  },
  {
    value: 37,
    label: "离开本单位时间",
    type: 2,
    InfoType: 3,
  },
  {
    value: 38,
    label: "入沙工作时间",
    type: 2,
    InfoType: 3,
  },
  {
    value: 39,
    label: "首次入沙时间",
    type: 2,
    InfoType: 3,
  },
  {
    value: 40,
    label: "自沙特撤离时间",
    type: 2,
    InfoType: 3,
  },
  {
    value: 41,
    label: "入阿工作时间",
    type: 2,
    InfoType: 3,
  },
  {
    value: 42,
    label: "首次入阿时间",
    type: 2,
    InfoType: 3,
  },
  {
    value: 43,
    label: "自阿联酋撤离时间",
    type: 2,
    InfoType: 3,
  },
  {
    value: 44,
    label: "专业技术资格名称",
    type: 3,
    InfoType: 2,
  },
  {
    value: 45,
    label: "职称取得时间",
    type: 3,
    InfoType: 3,
  },
  {
    value: 46,
    label: "职业技能等级",
    type: 3,
    InfoType: 1,
  },
  {
    value: 47,
    label: "技能鉴定取得时间",
    type: 3,
    InfoType: 3,
  },
  {
    value: 48,
    label: "资质证书",
    type: 3,
    InfoType: 1,
  },
  {
    value: 49,
    label: "证书编号",
    type: 3,
    InfoType: 1,
  },
  {
    value: 50,
    label: "发证日期",
    type: 3,
    InfoType: 3,
  },
  {
    value: 51,
    label: "有效期限",
    type: 3,
    InfoType: 3,
  },
  {
    value: 52,
    label: "证书类型",
    type: 3,
    InfoType: 2,
  },
  {
    value: 53,
    label: "绩效评估周期",
    type: 3,
    InfoType: 3,
  },
  {
    value: 54,
    label: "评估结果",
    type: 3,
    InfoType: 1,
  },

  {
    value: 55,
    label: "当地雇主",
    type: 4,
    InfoType: 2,
  },

  {
    value: 56,
    label: "签证类型",
    type: 4,
    InfoType: 2,
  },
  {
    value: 57,
    label: "外事关系",
    type: 4,
    InfoType: 2,
  },
  {
    value: 58,
    label: "人员所在地信息",
    type: 4,
    InfoType: 2,
  },
  {
    value: 59,
    label: "入境号",
    type: 4,
    InfoType: 1,
  },
  {
    value: 60,
    label: "过往海外工作经历",
    type: 4,
    InfoType: 1,
  },
  {
    value: 61,
    label: "最近一次海外撤离记录",
    type: 4,
    InfoType: 1,
  },
  {
    value: 62,
    label: "当地工资卡-开户中文姓名",
    type: 5,
    InfoType: 1,
  },
  {
    value: 63,
    label: "开户英文姓名",
    type: 5,
    InfoType: 1,
  },
  {
    value: 64,
    label: "银行卡号(ACCOUNT NO.) ",
    type: 5,
    InfoType: 1,
  },
  {
    value: 65,
    label: "国际银行账号(IBAN NO.) ",
    type: 5,
    InfoType: 1,
  },
  {
    value: 66,
    label: "当地工资卡开户行",
    type: 5,
    InfoType: 1,
  },
  {
    value: 67,
    label: "银行识别码(BANK CODE)",
    type: 5,
    InfoType: 1,
  },
  {
    value: 68,
    label: "注册手机号",
    type: 5,
    InfoType: 1,
  },
  {
    value: 69,
    label: "注册薪资水平",
    type: 5,
    InfoType: 4,
  },
  {
    value: 70,
    label: "有效期",
    type: 5,
    InfoType: 3,
  },

  {
    value: 71,
    label: "员工照片",
    type: 1,
    InfoType: 1,
  },
  {
    value: 72,
    label: "暂住证职位名称",
    type: 4,
    InfoType: 1,
  },
  {
    value: 73,
    label: "暂住证职位名称（阿文）",
    type: 4,
    InfoType: 1,
  },
  {
    value: 74,
    label: "暂住证职位代码",
    type: 4,
    InfoType: 1,
  },
  {
    value: 75,
    label: "初始登录密码",
    type: 1,
    InfoType: 1,
  },
];
